/**
 * NewsReadersMode
 */
export enum NewsReadersMode {
    READ = 'read',
    UNREAD = 'unread'
}
